// extracted by mini-css-extract-plugin
module.exports = {"googleFontPicker":"GoogleFontSelect_googleFontPicker__1ukXl","placeholder":"GoogleFontSelect_placeholder__184JE","error":"GoogleFontSelect_error__2z5hh"};